"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Container.default;
  }
});

var _Container = _interopRequireDefault(require("./Container"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/Container/index.js
// module id = 472
// module chunks = 0